import React from 'react';
import SidebarComponent from './SidebarComponent';
import { PageHeader } from '../../components';

const OperationAndMaintenance: React.FC = () => {
  return (
    <>
      <PageHeader title="Operation & Maintenance" breadcrumbs={[{ label: "Services", path: "/services" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/residential-1.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/residential-2.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Operation & Maintenance</h1>
              <p>We offer long-term and short-term O&M contracts for water and wastewater treatment plants. Our O&M services ensure continuous plant performance, minimized downtime, and regulatory compliance. We deploy trained personnel, monitoring tools, and chemical support to maintain optimum plant conditions.</p>

              <h3 className="mb-4">Scope Includes:</h3>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Manpower deployment</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Daily operations & reporting</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Preventive and corrective maintenance</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Chemical supply and inventory</p>

              <h3 className="mb-4">Why WTIL O&M?</h3>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>SLA-bound performance metrics</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Emergency response & remote diagnostics</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Asset management & spares tracking</p>
            </div>

            <div className="col-lg-4">
              <SidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default OperationAndMaintenance;
